import { object, string } from '@gogame/schemas';

import { CONCEPT_CREATION_PERIOD, CREATIVE_CREATION_PERIOD } from './constants';

export const validationSchema = object({
  [CONCEPT_CREATION_PERIOD]: string(),
  [CREATIVE_CREATION_PERIOD]: string(),
});
